import type { DomainError } from '@core/domain/errors';
import { ErrorCategory, getUserFriendlyMessage } from '@core/domain/errors';

/**
 * Adapts generic errors to domain errors
 */
export function adaptGenericError(error: unknown): DomainError {
  const errorMessage =
    error instanceof Error
      ? error.message
      : typeof error === 'object' && error !== null && 'message' in error
        ? String((error as { message: unknown }).message)
        : 'An unexpected error occurred';

  // Check for authentication errors in the message
  if (errorMessage.toLowerCase().includes('invalid or expired session') || errorMessage.includes('UNAUTHENTICATED')) {
    const code = 'UNAUTHENTICATED';

    return {
      code,
      message: errorMessage,
      userMessage: getUserFriendlyMessage(ErrorCategory.AUTHENTICATION, errorMessage, code),
      category: ErrorCategory.AUTHENTICATION,
      details: null,
    };
  }

  const code = 'UNKNOWN_ERROR';

  return {
    code,
    message: errorMessage,
    userMessage: getUserFriendlyMessage(ErrorCategory.INTERNAL, errorMessage, code),
    category: ErrorCategory.INTERNAL,
    details: null,
  };
}
